import { TesteSociocomportamental } from '../../types/teste-sociocomportamental.types';

export const TESTE_SOCIOCOMPORTAMENTAL: TesteSociocomportamental = {
  urlVideoApresentacao: 'https://play.yduqs.videolib.live/player?token=28cbd8aa4af04a6c9bc3653ee7a52620',
  ativo: true,
};
